import FileProviderItemViewState, {
    FileProviderItemType,
} from '../store/schema/FileProviderItemViewState';
import { isImageFile } from 'owa-file';

const imageMimeTypes = {
    'image/gif': true,
    'image/png': true,
    'image/jpeg': true,
    'image/bmp': true,
    'image/webp': true,
};

export default function isFileProviderItemAnImage(item: FileProviderItemViewState): boolean {
    if (!item) {
        throw new Error('The file provider item should not be null');
    }

    if (item.type === FileProviderItemType.Folder) {
        return false;
    }

    return (
        (item.model.MimeType && item.model.MimeType.toLowerCase() in imageMimeTypes) ||
        isImageFile(item.model.Name) ||
        false
    ); /* if we have reaced here it means other conditions failed hence we should return false */
}
